export const UIConstant = {
    grid: {
        numColumns: 2,
    },
};
